import Client from "../AxiosClient";
const resource = "/private/rolegroups";

export default {
  //#region  group
  async list_group_user(id) {
    try {
      const response = await Client.get(
        `${resource}/list_group_user?account_id=${id}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_grouprole_account(body) {
    // console.log("getTarget");
    try {
      const response = await Client.post(
        `${resource}/update_grouprole_account`,
        body
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async list_group(params) {
    try {
      const response = await Client.get(
        `${resource}/list_group?group_id=${params.role_id}&group_name=${params.role_name}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error.message,
      };
    }
  },

  async lock_group(body) {
    try {
      const response = await Client.post(`${resource}/lock_group`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async create_group(body) {
    try {
      const response = await Client.post(`${resource}/create_group`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_group(body) {
    try {
      const response = await Client.post(`${resource}/update_group`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async list_group_role(group_id) {
    try {
      const response = await Client.get(
        `${resource}/list_group_role?group_id=${group_id}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_group_role(body) {
    // console.log("getTarget");
    try {
      const response = await Client.post(`${resource}/update_group_role`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  //#endregion

  //#region  role

  async list_role_user(id) {
    try {
      const response = await Client.get(
        `${resource}/list_role_user?account_id=${id}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async update_role_account(body) {
    // console.log("getTarget");
    try {
      const response = await Client.post(
        `${resource}/update_role_account`,
        body
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  async list_role(params) {
    try {
      const response = await Client.get(
        `${resource}/list_role?role_id=${params.role_id}&role_name=${params.role_name}`
      );
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async lock_role(body) {
    try {
      const response = await Client.post(`${resource}/lock_role`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async create_role(body) {
    try {
      const response = await Client.post(`${resource}/create_role`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },

  async update_role(body) {
    try {
      const response = await Client.post(`${resource}/update_role`, body);
      return response.data;
    } catch (error) {
      return {
        status: "failed",
        data: [],
        message: error,
      };
    }
  },
  //#endregion
};
